<div class="empty-state" role="status">
  <div class="empty-state__icon" aria-hidden="true">📚</div>

  @if (hasSearch && hasActiveFilters) {
    <h3 class="empty-state__title">{{ 'BROWSE_INDEX.NO_RESULTS' | translate }}</h3>
    <p class="empty-state__message">{{ 'BROWSE_INDEX.NO_RESULTS_SEARCH_FILTER' | translate }}</p>
    <div class="empty-state__actions">
      <button (click)="clearSearch.emit()">{{ 'BROWSE_INDEX.CLEAR_SEARCH' | translate }}</button>
      <button (click)="clearFilters.emit()">{{ 'FILTERS.CLEAR_ALL' | translate }}</button>
    </div>
  } @else if (hasSearch) {
    <h3 class="empty-state__title">{{ 'BROWSE_INDEX.NO_RESULTS_FOR' | translate }}</h3>
    <p class="empty-state__message">"{{ searchTerm }}"</p>
    <div class="empty-state__actions">
      <button (click)="clearSearch.emit()">{{ 'BROWSE_INDEX.CLEAR_SEARCH' | translate }}</button>
    </div>
  } @else if (hasActiveFilters) {
    <h3 class="empty-state__title">{{ 'BROWSE_INDEX.NO_RESULTS_FILTER' | translate }}</h3>
    <div class="empty-state__actions">
      <button (click)="clearFilters.emit()">{{ 'FILTERS.CLEAR_ALL' | translate }}</button>
    </div>
  } @else {
    <h3 class="empty-state__title">{{ 'BROWSE_INDEX.EMPTY_CATALOG' | translate }}</h3>
  }
</div>
